import { state } from '../state'

/**
 * Track an error.
 * @param error - The error object.
 * @param context - The context of the error.
 */
export async function error(error: Error, context?: Record<string, string>): Promise<void> {
  await state.eventBus.dispatchError({
    error,
    context,
  })
}
